import {forwardRef, useMemo, useState} from 'react';
import PropTypes from 'prop-types';

import {HoverHandler} from '@gisatcz/ptr-core';
import {ScatterChart as PantherScatterChart} from '@gisatcz/ptr-charts';
import {utils} from '@gisatcz/ptr-utils';
import {ButtonSwitch, ButtonSwitchOption} from '@gisatcz/ptr-atoms';
import ChartWrapper from '../../../../../common/charts/ChartWrapper';
import ReactResizeDetector from 'react-resize-detector';

import TimeRangeChart from '../../../../../common/charts/TimeRangeChart';
import ScatterChart from '../../../../../common/charts/ScatterChart';

import getData from './getData';
// import getDataForNivoChart from './getDataForNivoChart';
import chartDefs from './chartDefs';

import './style.scss';

const renderNode = (ctx, node) => {
	const {x, y, size} = node;
	ctx.beginPath();
	ctx.moveTo(x - size / 2, y);
	ctx.lineTo(x + size / 2, y);
	ctx.moveTo(x, y - size / 2);
	ctx.lineTo(x, y + size / 2);
	// ctx.strokeStyle = hovered ? 'red' : node.color;
	ctx.strokeStyle = node.color;
	ctx.stroke();
};

// eslint-disable-next-line react/display-name
const RangeChartWrapper = forwardRef(
	({data, hovered, fixedRange, onHover}, ref) => {
		const metadata = chartDefs.scatterChart.metadata;
		const overviewChartMetadata = chartDefs.scatterChart.overviewChartMetadata;

		return (
			<TimeRangeChart
				{...{
					ChartComponent: ScatterChart,
					data,
					chartComponentSettings: {
						renderNode: (ctx, node) => {
							return renderNode(ctx, node, hovered);
						},
						yScale: fixedRange
							? {
									...metadata?.settings?.yScale,
									min: -200,
									max: 200,
							  }
							: metadata?.settings?.yScale,
					},
					metadata,
					overviewChartMetadata,
					onHover,
				}}
				ref={ref}
			/>
		);
	}
);

RangeChartWrapper.propTypes = {
	data: PropTypes.array,
	fixedRange: PropTypes.bool,
	hovered: PropTypes.array,
	onHover: PropTypes.func,
};

const InterferometryChart = ({
	attributes,
	rangeType = 'dynamic',
	setRangeType,
}) => {
	const [width, setWidth] = useState(null);
	const remSize = utils.getRemSize();

	const [points, min, max] = useMemo(
		() => getData(attributes, rangeType),
		[attributes, rangeType]
	);

	// TODO WIP: time range chart
	// const nivoData = useMemo(
	// 	() => getDataForNivoChart(attributes, rangeType),
	// 	[attributes, rangeType]
	// );

	return (
		<ChartWrapper
			title={
				<h5>
					PS point displacement trend <span>(mm)</span>
				</h5>
			}
			settingItems={[
				{
					name: 'Y axis range',
					content: (
						<ButtonSwitch ghost small onClick={setRangeType}>
							<ButtonSwitchOption value="fixed" active={rangeType === 'fixed'}>
								Fixed (from -200 to 200)
							</ButtonSwitchOption>
							<ButtonSwitchOption
								value="dynamic"
								active={rangeType === 'dynamic'}
							>
								Dynamic (focused on breaks)
							</ButtonSwitchOption>
						</ButtonSwitch>
					),
				},
			]}
		>
			<HoverHandler>
				<div className="">
					<ReactResizeDetector handleWidth onResize={setWidth} />
					<PantherScatterChart
						key="interferometry-chart"
						height={20}
						width={width / remSize}
						data={points}
						keySourcePath="key"
						nameSourcePath="key"
						xSourcePath="date"
						ySourcePath="value"
						pointRadius={5}
						border
						xScaleType="time"
						xOptions={{
							axisValueFormat: 'YYYY',
							popupValueFormat: 'D MMMM YYYY',
							name: 'Date',
							min: '2014-11-01T00:00:00.000Z',
							max: '2021-06-15T00:00:00.000Z',
						}}
						xValuesSize={2.5}
						yOptions={{
							tickCount: 10,
							min,
							max,
							unit: 'mm',
							name: 'Point displacement',
						}}
						yValuesSize={2.5}
						withoutYbaseline={false}
						diverging
						pointSymbol="plus"
					/>
				</div>
			</HoverHandler>

			{/* TODO WIP: time range chart */}
			{/*<div style={{height: '23rem', marginTop: '.5rem'}}>*/}
			{/*	<NivoChartHoverWrapper*/}
			{/*		activeChartKey="scatterChart"*/}
			{/*		margin={{*/}
			{/*			...(chartDefs?.scatterChart?.metadata?.settings?.margin*/}
			{/*				? chartDefs.scatterChart.metadata.settings.margin*/}
			{/*				: {}),*/}
			{/*		}}*/}
			{/*	>*/}
			{/*		<RangeChartWrapper*/}
			{/*			data={nivoData}*/}
			{/*			fixedRange={rangeType === 'fixed'}*/}
			{/*		/>*/}
			{/*	</NivoChartHoverWrapper>*/}
			{/*</div>*/}
		</ChartWrapper>
	);
};

InterferometryChart.propTypes = {
	attributes: PropTypes.object,
	rangeType: PropTypes.string,
	setRangeType: PropTypes.func,
};

export default InterferometryChart;
